function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.7557 91C76.6614 91 90.2838 70.223 90.2838 52.2052C90.2838 51.6151 90.2838 51.0276 90.2442 50.4428C92.8944 48.5126 95.182 46.1228 97 43.3851C94.5286 44.4877 91.907 45.2109 89.2226 45.5303C92.0493 43.8263 94.165 41.1462 95.1758 37.9888C92.5177 39.577 89.6097 40.6963 86.5773 41.2983C82.3799 36.8043 75.7103 35.7043 70.3084 38.6153C64.9065 41.5263 62.1158 47.7242 63.501 53.7337C52.6134 53.1841 42.4694 48.006 35.5936 39.4881C31.9996 45.7181 33.8353 53.6882 39.7859 57.6892C37.631 57.6249 35.5231 57.0396 33.64 55.9826C33.64 56.0384 33.64 56.0969 33.64 56.1554C33.6418 62.6458 38.1854 68.236 44.5036 69.5212C42.5101 70.0686 40.4184 70.1487 38.3894 69.7551C40.1633 75.3094 45.247 79.1143 51.0402 79.2239C46.2453 83.0184 40.322 85.0782 34.2234 85.0721C33.1461 85.07 32.0697 85.0043 31 84.8753C37.1925 88.8768 44.3978 90.9992 51.7557 90.9894"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "33 33 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.3ad4a4df.svg";
export { ForwardRef as ReactComponent };